import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { AdminDeviceService, DeviceOperationVM, DeviceSearchVM } from '../services/api';
import { CheckOutComponent } from './check-out/check-out.component';
import { DeviceOperationComponent } from './device-operation/device-operation.component';

@Component({
  selector: 'app-device-status',
  templateUrl: './device-status.component.html',
  styleUrls: ['./device-status.component.scss']
})
export class DeviceStatusComponent implements OnInit {
  @Input() device: DeviceSearchVM = <DeviceSearchVM>{};
  @Input() disabled: boolean = false;
  currentStatus: string = "NO STATUS";
  scanned: string = "SCANNED";
  notScanned: string = "NOT SCANNED";
  checkedOut: string = "CHECKED OUT";
  returned: string = "RETURNED";
  suspectedMissing: string = "SUSPECTED MISSING";
  suspectedStolen: string = "SUSPECTED STOLED";
  confirmedMissing: string = "CONFIRMED MISSING";
  confirmedStoled: string = "CONFIRMED STOLEN";
  lockedOut: string = "LOCKED OUT";
  inactive: string = "INACTIVE";
  btnColor: string="green";
  @Output("change") statusChange: EventEmitter<DeviceOperationVM> = new EventEmitter<DeviceOperationVM>();

  constructor(private dialog: MatDialog,
    private deviceService: AdminDeviceService,
private toastr:ToastrService  ) {

  }

  ngOnInit(): void {
    this.currentStatus = this.device.status??"NO STATUS";
    switch (this.device.status) {
      case this.scanned:
        this.btnColor = "scanned"
        break;
      case this.notScanned:
        this.btnColor = "not-scanned";
        break;
      case this.checkedOut:
        this.btnColor = "checked-out";
        break;
      case this.returned:
        this.btnColor = "recovered";
        break;
      case this.suspectedMissing:
        this.btnColor = "suspected-missing";
        break;
      case this.suspectedStolen:
        this.btnColor = "suspected-stolen";
        break;
      case this.confirmedMissing:
        this.btnColor = "confirmed-missing";
        break;
      case this.confirmedStoled:
        this.btnColor = "confirmed-stolen";
        break;
      case this.lockedOut:
        this.btnColor = "locked-out";
        break;
      case this.inactive:
        this.btnColor = "inactive";
        break;
      default:
        this.btnColor = "no-status";
    }
  }

  menuClicked(event:any) {
    event.stopPropagation();
    return;
  }

  checkout() {
    this.dialog.open(CheckOutComponent, {
      data: { id: this.device.id, uuid:this.device.deviceUuid },
      width: "800px"
    }).afterClosed().pipe(first()).subscribe(result => {
      console.log(result);
      if (result) {
        this.deviceService.adminDeviceCheckOutPost(result).pipe(first()).subscribe(postResult => {
          this.statusChange.emit(postResult);
          this.toastr.success("Device was checked out successfully.");
        }, err => {
            this.toastr.error(err.error);
        });
      }
    });
  }

  suspectMissing() {
    this.showPopUp("Mark Device Suspected Missing", this.suspectedMissing);
  }

  suspectStolen() {
    this.showPopUp("Mark Device Suspected Stolen", this.suspectedStolen);
  }

  confirmMissing() {
    this.showPopUp("Mark Device Confirm Missing", this.confirmedMissing);
  }

  confirmStolen() {
    this.showPopUp("Mark Device Confirm Stolen", this.confirmedStoled);
  }

  lockout() {
    this.showPopUp("Mark Device Lockout", this.lockedOut);
  }

  recover() {
    this.showPopUp("Mark Device Recovered", this.returned);
  }

  markInactive() {
    this.showPopUp("Mark Device Inactive", this.inactive);
  }

  private showPopUp(title:string,operation:string) {
    this.dialog.open(DeviceOperationComponent, {
      data: { id: this.device.id, title: title },
      width: "800px"
    }).afterClosed().pipe(first()).subscribe(result => {
      console.log(result);
      if (result) {
        this.deviceService.adminDeviceAddDeviceOperationPost({
          deviceId: this.device.id??-1,
          notes: result.notes,
          opType: operation
        }).pipe(first()).subscribe(postResult => {
          this.statusChange.emit(postResult);
          this.toastr.success("Operation was successful.")
        }, err => { this.toastr.error(err.error)});
      }
    });
  }

}
